import  apiClient  from './apiClient';

interface CollabApplicationResponse {
  msg: string;
  status: number;
  data: {
    application_id: number;
    post_id: number;
  };
}

export const applyCollabs = async (
  collabId: string,
  text: string,
  media?: File[]
): Promise<CollabApplicationResponse> => {
  try {
    if (!media|| media.length === 0) {
      // Text-only application
      const response = await apiClient.post(`/core/collabs/apply/`, {
        collab_id: collabId,
        text
      });
      return response.data;
    } else {
      const formData = new FormData();
    formData.append('collab_id', collabId.toString());
    formData.append('text', text);
    
    // Add media files with media_ prefix instead of image_
    const mediaOrder: string[] = [];
    
    media.forEach((file, index) => {
      const mediaKey = `media_${index + 1}`;
      formData.append(mediaKey, file);
      mediaOrder.push(mediaKey);
    });
    
    // Only append media_order if there are media files
    if (mediaOrder.length > 0) {
      formData.append('media_order', JSON.stringify(mediaOrder));
    }
    
    const response = await apiClient.post(
      `/core/collabs/apply/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
    }
  } catch (error) {
    console.error('Error applying to collab:', error);
    throw error;
  }
};
